import {createSlice} from "@reduxjs/toolkit";

const initialHatcheryChangesState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  entities: null,
  hatcheryChangeForEdit: undefined,
  lastError: null
};
export const callTypes = {
  list: "list",
  action: "action"
};

export const hatcheryChangesSlice = createSlice({
  name: "hatcheryChanges",
  initialState: initialHatcheryChangesState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    // getHatcheryChangeById
    hatcheryChangeFetched: (state, action) => {
      state.actionsLoading = false;
      state.hatcheryChangeForEdit = action.payload.hatcheryChangeForEdit;
      state.error = null;
    },
    // findHatcheryChanges
    hatcheryChangesFetched: (state, action) => {
      const { totalCount, entities } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.entities = entities;
      state.totalCount = totalCount;
    },
    pastHatcheryChangesFetched: (state, action) => {
      const { totalCount, entities } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.entities = entities;
      state.totalCount = totalCount;
    },
    // createHatcheryChange
    hatcheryChangeCreated: (state, action) => {
      state.actionsLoading = false;
      state.error = null;
      state.entities.push(action.payload.hatcheryChange);
    },
    // updateHatcheryChange
    hatcheryChangeUpdated: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.map(entity => {
        if (entity.id === action.payload.hatcheryChange.id) {
          return action.payload.hatcheryChange;
        }
        return entity;
      });
    },
    // deleteHatcheryChange
    hatcheryChangeDeleted: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.filter(el => el.id !== action.payload.id);
    },
    // deleteHatcheryChanges
    hatcheryChangesDeleted: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.filter(
        el => !action.payload.ids.includes(el.id)
      );
    },
    // hatcheryChangesUpdateState
    hatcheryChangesStatusUpdated: (state, action) => {
      state.actionsLoading = false;
      state.error = null;
      const { ids, status } = action.payload;
      state.entities = state.entities.map(entity => {
        if (ids.findIndex(id => id === entity.id) > -1) {
          entity.status = status;
        }
        return entity;
      });
    }
  }
});
